import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import Product from './product';
import SearchProductControl from './search-product-control';
import OnboardingContext from '../common/context';

const ScrollableContainer = styled.div`
  overflow-y: auto;
  flex-grow: 2;
  padding-right: 5px;

  ${props => (props.theme.isMobile ? `
    width: 100%;
  ` : `
    width: 36vw;
    max-width: 461px;
    min-height: 80px;
  `)}
`;

const match = (text, query) => text.toLowerCase().includes(query);

const filter = (q, list, limit) => {
  const queries = _.compact(q.toLowerCase().split(/\s*,\s*/));

  if (!queries.length) {
    return list.slice(0, limit);
  }

  return list.filter(
    product => queries.some(
      query => match(product.code, query) || match(product.companyName, query),
    ),
  ).slice(0, limit);
};

export default function Available() {
  const { state } = React.useContext(OnboardingContext);
  const [products, setProducts] = React.useState([]);
  const [queries, setQueries] = React.useState('');

  React.useEffect(() => {
    setProducts(filter(queries, state.productsAvailable, 300));
  }, [state.productsAvailable, queries]);

  return (
    <React.Fragment>
      <SearchProductControl onSearch={d => setQueries(d)} />
      <ScrollableContainer>
        {products.map(p => <Product {...p} followed={false} key={p.slug} />)}
      </ScrollableContainer>
    </React.Fragment>
  );
}
